import {useCallback, useMemo} from 'react';
import {QueryStatus} from '@reduxjs/toolkit/query/react';
import debounce from 'lodash/debounce';
import {mapPostInfoApiArgs} from 'services/advancedSearch/mappers/mapPostInfoApiArgs';
import type {Column, PostInfoArgs} from '../types';
import {useLazyPostInfoQuery} from '../advancedSearchApi';

export const useAdvancedSearchInfo = (allColumns: Column[]) => {
  const [postInfo, {status, data}] = useLazyPostInfoQuery();

  const searcher = useCallback(
    (args: PostInfoArgs) => {
      const apiArgs = mapPostInfoApiArgs(args, allColumns);

      if (!apiArgs) {
        return;
      }

      return postInfo(apiArgs);
    },
    [allColumns, postInfo],
  );

  const debouncedPostInfo = useMemo(() => debounce(searcher, 200), [searcher]);

  return {
    postInfo: debouncedPostInfo,
    isLoading: status === QueryStatus.pending,
    data: data ?? {rows: [], hits: 0},
  };
};
